<template>
<div>
    <page-title-bar></page-title-bar>
    <app-section-loader :status="loader"></app-section-loader>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12 md11>
                <app-card pt-0>
                    <v-card-title>
                        <h4>BẢNG TỔNG HỢP PHIẾU THU TIỀN</h4>
                        <v-spacer></v-spacer>
                        <v-layout row justify-end>
                            <v-flex xs12 md4>
                                <v-text-field
                                v-model="search"
                                prepend-icon="search"
                                label="Tìm kiếm"
                                single-line
                                hide-details
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="chosen_building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :rows-per-page-items="rowPerPage"
                    >
                        <template #headers="props">
                            <tr>
                                <th class="text-xs-center fw-bold" v-for="header in props.headers" :key="header.text">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template #items="props">
                            <td>{{ props.item.room_id }}</td>
                            <td>{{ props.item.room_price | formatNumber }}</td>
                            <td>{{ props.item.day_count | formatNumber }}</td>
                            <td>{{ props.item.room_bill | formatNumber }}</td>
                            <td>{{ props.item.electric_1 | formatNumber }}</td>
                            <td>{{ props.item.electric_2 | formatNumber }}</td>
                            <td>{{ props.item.electric_amount | formatNumber }}</td>
                            <td>{{ props.item.electric_bill | formatNumber }}</td>
                            <td>{{ props.item.water_price | formatNumber }}</td>
                            <td>{{ props.item.water_1 | formatNumber }}</td>
                            <td>{{ props.item.water_2 | formatNumber }}</td>
                            <td>{{ props.item.water_amount | formatNumber }}</td>
                            <td>{{ props.item.water_bill | formatNumber }}</td>
                            <td>{{ props.item.garbage_price | formatNumber }}</td>
                            <td>{{ props.item.internet_price | formatNumber }}</td>
                            <td>{{ props.item.packing_price | formatNumber }}</td>
                            <td>{{ props.item.washing_price | formatNumber }}</td>
                            <td>{{ props.item.ac_price | formatNumber }}</td>
                            <td>{{ props.item.sum_total | formatNumber }}</td>
                        </template>
                    </v-data-table>
                </app-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import api from "Api";

export default {
    data() {
        return {
            loader: false,
            search:'',
            headers: [
                { text: "Số Phòng", align: "center", value: "room_id" },
                { text: "Giá Phòng", align: "center", value: "roomPrice" },
                { text: "Ngày ở", align: "center", value: "day_count" },
                { text: "Tiền phòng", align: "center", value: "room_bill" },
                { text: "Số điện đầu", value: "electric_1" },
                { text: "Số điện cuối", value: "electric_2" },
                { text: "Lượng điện", value: "electric_amount" },
                { text: "Tiền điện", value: "electric_bill" },
                { text: "Đơn giá nước", value: "water_price" },
                { text: "Số nước đầu", value: "water_1" },
                { text: "Số nước cuối", value: "water_2" },
                { text: "Lượng nước", value: "water_amount" },
                { text: "Tiền nước", value: "water_bill" },
                { text: "Tiền rác", value: "garbage_price" },
                { text: "Tiền internet", value: "internet_price" },
                { text: "Tiền xe", value: "packing_price" },
                { text: "Máy giặt", value: "washing_price" },
                { text: "Máy lạnh", value: "ac_price" },
                { text: "Tổng cộng", value: "total_bill" },
            ],
            list_building: [
                {text: 'Bảo Ngọc', value: 'BN'},
                {text: 'Gia Bảo', value: 'GB'},
                {text: 'Thanh Tâm', value: 'TT'},
                {text: 'Xuân Anh', value: 'XA'},
                {text: 'Mai Anh', value: 'MA'},
                {text: 'Tất cả', value: ''},
            ],
            chosen_building: 'BN',
            items: [],
            loading: {
                submit: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}]
        };
    },
    mounted() {
        this.getTablesData();
    },
    methods: {
        getTablesData() {
            let dummy_data = [
                {
                    room_id: '101GB',
                    room_price: 5000000,
                    day_count: 30,
                    electric_1: 4298,
                    electric_2: 4471,
                    water_price: 15000,
                    water_1: 189,
                    water_2: 210,
                    garbage_price: 50000,
                    internet_price: 0,
                    packing_price: 100000,
                    washing_price: 0,
                    ac_price: '300,000',
                    sum_total: '5,984,000'
                },
            ]
            for (let index = 0; index < 7; index++) {
                const element = dummy_data[0];
                this.items.push(element)
            }
        }
    }
};
</script>
